import ConfirmAddressSuccess from 'features/personalInfo/confirmYourAddress/screens/ConfirmAddressSuccessScreen/ConfirmAddressSuccessScreen';
import React from 'react';

export default function AddressSuccess() {
  return <ConfirmAddressSuccess />;
}
